import { mapParamsBySchema } from '../../../util';
import { apiRequest } from '../../../Services/Common/ApiRequest';
import Global from '../../../Services/Common/Global';
import Store from '../../../Store/Store';
import { WOE_BASIC_01_Schema } from './M_WOE_BASIC_01_Schema';
import useSaveMutation from '../../../Hooks/apis/useSaveMutaion';

/** 작업종료 등록 저장 SaveWoeBasicU2 */
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (vars) => {
    const row = vars?.row ?? vars;
    const userInfo =
      vars?.userInfo ?? Store.getState()?.BaseInfo?.userInfo;
    const context = { ...row, userInfo };
    const payload = mapParamsBySchema(
      WOE_BASIC_01_Schema.mapper.save1,
      context
    );
    return apiRequest(
      'post1',
      Global.urls.WorkEnd.saveWoeBasicU2,
      payload
    );
  }, options);
};
